'use strict';

var _ = require('lodash');
var SortColumnOptionsFactory = function SortColumnOptionsFactory() {
  function SortColumnOptions() {
    var options = Array.isArray(arguments[0]) ? arguments[0].slice() : Array.prototype.slice.call(arguments);
    this.originalOptions = buildOptions(options.slice());
    this.availableOptions = buildOptions(options.slice());
  }
  function buildOptions(columns) {
    return _.chain(columns).transform(function (result, column) {
      if (Array.isArray(column.columns) && column.columns.length >= 1) {
        return result.push(buildOptions(column.columns));
      } else if (column.visible && column.filterable !== false) {
        var label = column.groupTitle ? column.groupTitle + ' ' + column.title : column.title;
        return result.push({
          field: column.field,
          label: label,
          fieldAlias: column.fieldAlias
        });
      }
    }).flatten().value();
  }
  SortColumnOptions.prototype.filterOptions = function (columnsToFilter) {
    var columnMap = {};
    columnsToFilter.forEach(function (c) {
      columnMap[c] = true;
    });
    this.availableOptions = _.filter(this.originalOptions, function (column) {
      return columnMap[column.field] !== true;
    });
  };
  return SortColumnOptions;
};
module.exports = SortColumnOptionsFactory;